// extracted by mini-css-extract-plugin
module.exports = {"embeddedForm":"form_embeddedForm__2jbRa"};